import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

var COLOR_BG_CLASS_MAPPING = {
  primary: "bg-primary",
  secondary: "bg-secondary",
  success: "bg-success",
  warning: "bg-warning",
  danger: "bg-danger",
  info: "bg-info"
};
var Status = function Status(_a) {
  var _b = _a.color,
    color = _b === void 0 ? "primary" : _b,
    _c = _a.bold,
    bold = _c === void 0 ? false : _c,
    children = _a.children;
  var boldClass = bold ? "font-bold" : "";
  var lampClassNames = "rounded-full";
  return /*#__PURE__*/React.createElement("div", {
    className: "flex",
    "data-test-role": "status-lamp"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center h-lg"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames([lampClassNames, COLOR_BG_CLASS_MAPPING[color]]),
    style: {
      height: "8px",
      width: "8px",
      flexShrink: 0
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(boldClass, " flex items-center ml-sm leading-100")
  }, children));
};
Status.propTypes = {
  color: PropTypes.oneOf(Object.keys(COLOR_BG_CLASS_MAPPING)),
  bold: PropTypes.bool,
  children: PropTypes.node
};

export { Status };
//# sourceMappingURL=index.es.js.map
